module.exports = __webpack_public_path__ + "img/remote-education.aa8b9b7f.jpg";